function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Dropdown } from '../Dropdown';
import { jsx as _jsx } from "react/jsx-runtime";
const getSelectColumnItems = (currentSelectColumnItems, option, index) => {
  const newSelectColumnItems = [...currentSelectColumnItems.slice(0, index), option, ...currentSelectColumnItems.slice(index + 1)];
  return newSelectColumnItems;
};
const getColumns = (currentColumns, index) => {
  const modifiedColumn = _objectSpread(_objectSpread({}, currentColumns[index]), {}, {
    isHidden: !currentColumns[index].isHidden
  });
  const newColumns = [...currentColumns.slice(0, index), modifiedColumn, ...currentColumns.slice(index + 1)];
  return newColumns;
};
export const ListTableColumnSelector = props => {
  const onSelectColumnItemsChange = (option, index) => {
    if (index === undefined) {
      return;
    }
    const newSelectColumnItems = getSelectColumnItems(props.options, option, index);
    props.onOptionsChange(newSelectColumnItems);
    const newColumns = getColumns(props.columns, index);
    props.onColumnsChange(newColumns);
  };
  return /*#__PURE__*/_jsx(Dropdown, {
    label: props.label,
    multiSelect: true,
    options: props.options,
    styles: _objectSpread({}, props.componentStyles),
    minSelectedItems: 2,
    maxItemsOverlay: 7,
    onChanged: onSelectColumnItemsChange
  });
};
ListTableColumnSelector.defaultProps = {
  componentStyles: {
    root: {
      width: 200
    }
  },
  label: 'Column Selector'
};